import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=25f5a670&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f5a670')) {
      api.createRecord('25f5a670', component.options)
    } else {
      api.reload('25f5a670', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=25f5a670&", function () {
      api.rerender('25f5a670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/History/Index.vue"
export default component.exports